import { WorkerSalaryType } from "model/Salary";

interface CalculateMonthlyPayoutSalaryParams {
  readonly salary?: number | null;
  readonly salaryType?: WorkerSalaryType | null;
  readonly workPercentage?: number | null;
}

const monthlySalaryFormatter = new Intl.NumberFormat("sv-SE", {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export function calculateMonthlyPayoutSalary({
  salary,
  salaryType,
  workPercentage,
}: CalculateMonthlyPayoutSalaryParams): number | null {
  if (
    salaryType !== WorkerSalaryType.MONTHLY ||
    salary == null ||
    !Number.isFinite(salary) ||
    salary < 0 ||
    workPercentage == null ||
    !Number.isFinite(workPercentage) ||
    workPercentage < 0 ||
    workPercentage >= 1
  ) {
    return null;
  }

  return Math.round(salary * workPercentage);
}

export function formatMonthlySalary(value: number): string {
  return `${monthlySalaryFormatter.format(value)} kr`;
}
